import React from 'react';
import AppRoutes from './routes';
import { ConfigProvider } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { AppInit } from 'AppInit';
import useAuthContext from 'stores/auth-context';

const App: React.FC = () => {
  const { accessToken } = useAuthContext();
  return (
    <ConfigProvider locale={viVN}>
      <div className='App'>
        {accessToken && <AppInit />}
        <AppRoutes />
      </div>
    </ConfigProvider>
  );
};

export default App;
